import React, { useMemo, useState } from "react";
import "../assets/Wallet/WalletTransaction.css";

const WalletTransaction = () => {
  /* 🔹 DUMMY DATA (Replace with API later) */
  // const [data] = useState(
  //   [...Array(40)].map((_, i) => ({
  //     id: i + 1,
  //     narration: "Paid on account closure to account: H02RDF00003",
  //     amount: (Math.random() * 500000).toFixed(2),
  //     factor: i % 2 === 0 ? "CR" : "DR",
  //     date: `2025-04-${String((i % 28) + 1).padStart(2, "0")} 13:05:20`,
  //   }))
  // );
  const [data,setdata]=useState([]);

  /* 🔹 STATES */
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [factor, setFactor] = useState("all");
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(10);
  const [page, setPage] = useState(1);

  /* 🔹 FILTER LOGIC */
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const itemDate = item.date.split(" ")[0];

      const dateMatch =
        (!fromDate || itemDate >= fromDate) &&
        (!toDate || itemDate <= toDate);

      const factorMatch =
        factor === "all" || item.factor.toLowerCase() === factor;

      const searchMatch = `${item.narration} ${item.amount} ${item.factor}`
        .toLowerCase()
        .includes(search.toLowerCase());

      return dateMatch && factorMatch && searchMatch;
    });
  }, [data, fromDate, toDate, factor, search]);

  /* 🔹 PAGINATION */
  const totalPages = Math.ceil(filteredData.length / entries);
  const paginatedData = filteredData.slice(
    (page - 1) * entries,
    page * entries
  );

  /* 🔹 DOWNLOAD CSV */
  const downloadCSV = () => {
    const rows = [
      ["Narration", "Amount", "Factor", "Date"],
      ...filteredData.map((i) => [
        i.narration,
        i.amount,
        i.factor,
        i.date,
      ]),
    ];

    const csv = rows.map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "wallet_transactions.csv";
    link.click();
  };

  /* 🔹 DOWNLOAD EXCEL */
  const downloadExcel = () => {
    const table = `
      <table>
        <tr><th>Narration</th><th>Amount</th><th>Factor</th><th>Date</th></tr>
        ${filteredData
          .map(
            (i) =>
              `<tr><td>${i.narration}</td><td>${i.amount}</td><td>${i.factor}</td><td>${i.date}</td></tr>`
          )
          .join("")}
      </table>
    `;

    const blob = new Blob([table], {
      type: "application/vnd.ms-excel",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "wallet_transactions.xls";
    link.click();
  };

  /* 🔹 PRINT */
  const printTable = () => {
    const content = document.querySelector(
      ".wallet-transaction-table-wrapper"
    ).innerHTML;

    const w = window.open("");
    w.document.write(`<html><body>${content}</body></html>`);
    w.print();
    w.close();
  };

  return (
    <div className="wallet-transaction-app">
      {/* FILTER SECTION */}
      <section className="wallet-transaction-filter-section">
        <h2 className="wallet-transaction-filter-title">
          <i className="fas fa-filter"></i> Filter Transactions
        </h2>

        <form
          className="wallet-transaction-filter-form"
          onSubmit={(e) => {
            e.preventDefault();
            setPage(1);
          }}
        >
          <div className="wallet-transaction-filter-fields">
            <div className="wallet-transaction-field">
              <label>From Date</label>
              <input type="date" onChange={(e) => setFromDate(e.target.value)} />
            </div>

            <div className="wallet-transaction-field">
              <label>To Date</label>
              <input type="date" onChange={(e) => setToDate(e.target.value)} />
            </div>

            <div className="wallet-transaction-field">
              <label>Factor</label>
              <select onChange={(e) => setFactor(e.target.value)}>
                <option value="all">All</option>
                <option value="cr">CR</option>
                <option value="dr">DR</option>
              </select>
            </div>
          </div>

          <button className="wallet-transaction-filter-btn">
            <i className="fas fa-search"></i> Filter
          </button>
        </form>
      </section>

      {/* TRANSACTIONS */}
      <section className="wallet-transaction-transactions">
        <h3 className="wallet-transaction-title">
          <i className="fas fa-wallet"></i> Wallet Transactions
        </h3>

        {/* ACTIONS */}
        <div className="wallet-transaction-actions">
          <div className="wallet-transaction-buttons">
            <button className="wallet-transaction-btn csv" onClick={downloadCSV}>
              <i className="fas fa-file-csv"></i> CSV
            </button>
            <button
              className="wallet-transaction-btn excel"
              onClick={downloadExcel}
            >
              <i className="fas fa-file-excel"></i> Excel
            </button>
            <button className="wallet-transaction-btn print" onClick={printTable}>
              <i className="fas fa-print"></i> Print
            </button>
          </div>

          <div className="wallet-transaction-controls">
            <div className="wallet-transaction-filter">
              <label>Show</label>
              <select
                value={entries}
                onChange={(e) => {
                  setEntries(Number(e.target.value));
                  setPage(1);
                }}
              >
                <option>10</option>
                <option>25</option>
                <option>50</option>
                <option>100</option>
              </select>
              <span>entries</span>
            </div>

            <div className="wallet-transaction-search">
              <input
                type="text"
                placeholder="Search..."
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="wallet-transaction-table-wrapper">
          <table className="wallet-transaction-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Narration</th>
                <th>Amount</th>
                <th>Factor</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length ? (
                paginatedData.map((item, i) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * entries + i + 1}</td>
                    <td>{item.narration}</td>
                    <td>₹ {item.amount}</td>
                    <td>
                      <span
                        className={`factor ${item.factor.toLowerCase()}`}
                      >
                        {item.factor}
                      </span>
                    </td>
                    <td>{item.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className="wallet-transaction-pagination">
          <span>
            Showing {(page - 1) * entries + 1} to{" "}
            {Math.min(page * entries, filteredData.length)} of{" "}
            {filteredData.length} entries
          </span>

          <div>
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>

            <button className="active">{page}</button>

            <button
              disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WalletTransaction;
